import appMode from 'helpers/getAppMode'
import React from 'react'
import { connect } from 'react-redux'

import { openTour } from 'redux/actions/tour.actions'
import { IconTour } from '_base/Icon/sub/IconTour'
import SideNavItem from './SideNavItem'

export function TourToggle({ steps, isMobile, isNormal, openTour }) {
  return (
    <SideNavItem
      type="sub"
      icon={IconTour}
      onClick={openTour}
      isNormal={isNormal}
      show={appMode.normal && !isMobile && steps?.length > 0}
    >
      Open App Tour
    </SideNavItem>
  )
}

const mapStateToProps = state => ({
  steps: state.tour.steps
})

export default connect(mapStateToProps, { openTour })(TourToggle)
